import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { BaseService } from 'src/app/core/base/base.service';
import { RestService } from 'src/app/core/service/rest.service';
import { GeneralHistoryPersonalCompleteModel } from 'src/app/model/general/history-personal-complete';
import { historyActions } from 'src/app/store/history/history.action';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class HistoryPersonalCompleteService extends BaseService {
  constructor(protected store: Store<any>, protected rest: RestService) {
    super();
  }

  getPersonId = (): Observable<number> =>
    this.store.select('history', 'personId');

  getHistory = (): Observable<GeneralHistoryPersonalCompleteModel> =>
    this.store.select('history', 'personalCompleteHistory');

  isSaving = (): Observable<boolean> => this.store.select('history', 'saving');

  loadHistory = (
    personId: number
  ): Observable<GeneralHistoryPersonalCompleteModel> =>
    this.rest
      .get<GeneralHistoryPersonalCompleteModel>({
        url: `${environment.endpoints.history}/personal-complete/{personId}`,
        urlParams: { personId },
      })
      .pipe(
        map((history) => (history ? history : { person: personId })),
        tap(this.setPersonalHistory)
      );

  save = (
    history: GeneralHistoryPersonalCompleteModel
  ): Observable<GeneralHistoryPersonalCompleteModel> =>
    this.rest
      .post({
        url: `${environment.endpoints.history}/personal-complete`,
        body: history,
      })
      .pipe(
        tap(this.setPersonalHistory),
        tap(
          () => this.addToSaved(),
          () => this.addToSaved()
        )
      );

  setPersonalHistory = (history: GeneralHistoryPersonalCompleteModel) =>
    this.store.dispatch(
      historyActions.setPersonalCompleteHistoryAction(history)
    );

  addToSaved = (value: number = 1, hasComplete: boolean = true) =>
    this.store.dispatch(
      historyActions.addToSavedAction({ value, hasComplete })
    );
}
